import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { Header, defaultScreenOptions } from '@bonanza-social/navigation';
import { CommunityJackpotNavigatorParamsList } from './CommunityJackpotNavigator.types';
import CommunityJackpotScreen from '../screens/CommunityJackpotScreen/CommunityJackpotScreen';
import CommunityJackpotRulesScreen from '../screens/CommunityJackpotRulesScreen/CommunityJackpotRulesScreen';
import CommunityJackpotClaimScreen from '../screens/CommunityJackpotClaimScreen/CommunityJackpotClaimScreen';
import CommunityJackpotWinnersScreen from '../screens/CommunityJackpotWinnersScreen/CommunityJackpotWinnersScreen';
import CommunityJackpotRewardsScreen from '../screens/CommunityJackpotRewardsScreen/CommunityJackpotRewardsScreen';
import CommunityJackpotHeaderRight from '../components/CommunityJackpotHeaderRight/CommunityJackpotHeaderRight';

const CommunityJackpot =
  createNativeStackNavigator<CommunityJackpotNavigatorParamsList>();

function CommunityJackpotNavigator() {
  return (
    <CommunityJackpot.Navigator screenOptions={defaultScreenOptions}>
      <CommunityJackpot.Screen
        name="CommunityJackpotScreen"
        options={{
          headerTransparent: true,
          header: (props) => (
            <Header {...props} headerRight={<CommunityJackpotHeaderRight />} />
          ),
        }}
        component={CommunityJackpotScreen}
      />
      <CommunityJackpot.Screen
        name="CommunityJackpotRulesScreen"
        component={CommunityJackpotRulesScreen}
      />
      <CommunityJackpot.Screen
        name="CommunityJackpotClaimScreen"
        component={CommunityJackpotClaimScreen}
      />
      <CommunityJackpot.Screen
        name="CommunityJackpotWinnersScreen"
        options={{
          header: (props) => (
            <Header {...props} headerRight={<CommunityJackpotHeaderRight />} />
          ),
        }}
        component={CommunityJackpotWinnersScreen}
      />
      <CommunityJackpot.Screen
        name="CommunityJackpotRewardsScreen"
        component={CommunityJackpotRewardsScreen}
        options={{
          header: (props) => (
            <Header {...props} headerRight={<CommunityJackpotHeaderRight />} />
          ),
        }}
      />
    </CommunityJackpot.Navigator>
  );
}

export default CommunityJackpotNavigator;
